import { render, staticRenderFns } from "./pcdetails.vue?vue&type=template&id=ec332e0c"
import script from "./pcdetails.vue?vue&type=script&lang=js"
export * from "./pcdetails.vue?vue&type=script&lang=js"
import style0 from "./pcdetails.vue?vue&type=style&index=0&id=ec332e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports